export const Loading = () =>{
        return (
          <div className="relative">
            <div class="fixed inset-0 flex justify-center items-center bg-black bg-opacity-20 dark:invert z-50">
              <div class="flex justify-center items-center space-x-3 h-40 w-80 animate-pulse-scale bg-jiojbm50 rounded-tl-full rounded-tr-full rounded-bl-full">
                <div class="h-8 w-8 bg-white rounded-full animate-custom-bounce [animation-delay:-0.3s]"></div>
                <div class="h-8 w-8 bg-white rounded-full animate-custom-bounce [animation-delay:-0.15s]"></div>
                <div class="h-8 w-8 bg-white rounded-full animate-custom-bounce"></div>
              </div>
            </div>
          </div>
        );
}